import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Embalaje from './Embalaje';
import ACCESS from '../../../ACCESS.js';

class Embalajes extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'embalaje/filter', deleteUrl: 'embalaje/delete', deleteField: 'embalaje_nombre', modUrl: '/Catalogo/Embalaje' },
      TableOp.Table('Embalajes', [
        { label: 'Clave', id: 'embalaje' },
        { label: 'Descripcion', id: 'embalaje_nombre' },
        { label: 'Grupo', id: 'grupo' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_EMBALAJES.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_EMBALAJES.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <Embalaje  onSave={() => {this.table()}}></Embalaje>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Embalajes)